import { Form, Input } from "decorator-form";
import { FontAwesomeIconStylesConfig, fontAwesomeIconStylesInput } from "../common/FontAwesomeIconStylesConfig";
import { registerWidget } from "common/form/register";
import ButtonSelect from "common/form/widgets/common/ButtonSelect";

const iconPositionWidget = registerWidget(ButtonSelect.withOptions([
	{value: 'left', label: 'Left', default: true},
	{value: 'right', label: 'Right'},
]), "string");

@Form({title: "Font Awesome Icon View Config"})
export default class FontAwesomeIconViewConfig {

	@Input({type: fontAwesomeIconStylesInput, title: "Font Awesome Icon Default State"})
	public bodyDefaultState?: FontAwesomeIconStylesConfig;

	@Input({type: iconPositionWidget, title: "Icon Position"})
	public iconPosition: "left" | "right";

}



// WEBPACK FOOTER //
// ./src/common/views/fontAwesomeIcon/FontAwesomeIconConfig.ts